import React, { useCallback } from 'react';
import { mergeClassNames, translateToSelectedMountBundle } from '../../../utils';
import { useTrackCustomEvent } from '../../../utils/useTrackCustomEvent';
import { useQuote, quoteActionTypes } from '../../../context/Quote';
import { useQuoteVisibility } from '../../../context/QuoteVisbility';
import { SecondaryButton } from '../../generic/Button';
import styles from './index.module.scss';

export default function BuyRoomButton({ bundles, className = null, style = null, dark = false }) {
  let trackCustomEvent = useTrackCustomEvent();
  const { dispatchQuote } = useQuote();
  const { toggleQuote } = useQuoteVisibility();

  const defaultMounts = bundles?.map(bundle => {
    const [defaultMount] = translateToSelectedMountBundle(bundle);
    return defaultMount;
  });

  const clickhandler = useCallback(() => {
    trackCustomEvent({
      category: 'Workspace interactions',
      action: `'Buy this room' clicked `,
      label: window.location.pathname,
    });
    defaultMounts && defaultMounts.forEach(bundle => dispatchQuote({ type: quoteActionTypes.add, item: bundle }));
    toggleQuote('open');
  }, [defaultMounts, dispatchQuote, toggleQuote, trackCustomEvent]);

  return (
    <SecondaryButton
      clickHandler={clickhandler}
      title={getInventoryAsString(bundles)}
      disabled={!bundles}
      className={mergeClassNames(className, styles.buyButton)}
      style={style}
      appearance={dark ? 'default' : 'light'}
    >
      Buy this room
    </SecondaryButton>
  );
}

function getInventoryAsString(items) {
  items = items ? items : [];
  return items.map(({ title }) => `Add the ${title} to your quote`).join(`\n`);
}
